export const blockUISettings = {
    css: {
        padding:         10,
        margin:          0,
        width:           '60%',
        top:             '40%',
        left:            '35%',
        textAlign:       'center',
        color:           '#000',
        border:          '3px solid #aaa',
        backgroundColor: '#fff',
        cursor:          'wait',
    },
    overlayCSS:  {
        backgroundColor: '#000',
        opacity:         0.01,
        cursor:          'wait'
    },
};